var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationMockups(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 680,
    height: 486,
    viewBox: "0 0 680 486",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_223_395)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_223_395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M624.154 6.57007H19.7099C12.4528 6.57007 6.56982 12.4531 6.56982 19.7102V387.633C6.56982 394.89 12.4528 400.773 19.7099 400.773H624.154C631.411 400.773 637.294 394.89 637.294 387.633V19.7102C637.294 12.4531 631.411 6.57007 624.154 6.57007Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M624.154 6.57007H19.7099C12.4528 6.57007 6.56982 12.4531 6.56982 19.7102V387.633C6.56982 394.89 12.4528 400.773 19.7099 400.773H624.154C631.411 400.773 637.294 394.89 637.294 387.633V19.7102C637.294 12.4531 631.411 6.57007 624.154 6.57007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_223_395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7099 6.57007H624.154C631.412 6.57007 637.294 12.4529 637.294 19.7102V48.6184H6.56982V19.7102C6.56982 12.4529 12.4526 6.57007 19.7099 6.57007Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.7099 6.57007H624.154C631.412 6.57007 637.294 12.4529 637.294 19.7102V48.6184H6.56982V19.7102C6.56982 12.4529 12.4526 6.57007 19.7099 6.57007Z",
    fill: "#00252E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.99 19.7102H57.159C55.3448 19.7102 53.874 21.181 53.874 22.9952V32.1933C53.874 34.0076 55.3448 35.4783 57.159 35.4783H181.99C183.804 35.4783 185.275 34.0076 185.275 32.1933V22.9952C185.275 21.181 183.804 19.7102 181.99 19.7102Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.932 21.0242H575.536C574.81 21.0242 574.222 21.6125 574.222 22.3382C574.222 23.0639 574.81 23.6522 575.536 23.6522H593.932C594.658 23.6522 595.246 23.0639 595.246 22.3382C595.246 21.6125 594.658 21.0242 593.932 21.0242Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.932 26.2802H575.536C574.81 26.2802 574.222 26.8685 574.222 27.5942C574.222 28.3199 574.81 28.9082 575.536 28.9082H593.932C594.658 28.9082 595.246 28.3199 595.246 27.5942C595.246 26.8685 594.658 26.2802 593.932 26.2802Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.932 31.5363H575.536C574.81 31.5363 574.222 32.1246 574.222 32.8503C574.222 33.576 574.81 34.1643 575.536 34.1643H593.932C594.658 34.1643 595.246 33.576 595.246 32.8503C595.246 32.1246 594.658 31.5363 593.932 31.5363Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4103 160.309C102.827 160.309 116.946 146.19 116.946 128.773C116.946 111.356 102.827 97.2367 85.4103 97.2367C67.9933 97.2367 53.874 111.356 53.874 128.773C53.874 146.19 67.9933 160.309 85.4103 160.309Z",
    fill: "url(#paint0_linear_223_395)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.323 105.121H155.71C154.621 105.121 153.739 106.003 153.739 107.092V113.662C153.739 114.75 154.621 115.633 155.71 115.633H227.323C228.412 115.633 229.294 114.75 229.294 113.662V107.092C229.294 106.003 228.412 105.121 227.323 105.121Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.57 126.145H155.71C154.621 126.145 153.739 127.027 153.739 128.116V129.43C153.739 130.518 154.621 131.401 155.71 131.401H414.57C415.658 131.401 416.541 130.518 416.541 129.43V128.116C416.541 127.027 415.658 126.145 414.57 126.145Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.67 136.657H155.71C154.621 136.657 153.739 137.539 153.739 138.628V139.942C153.739 141.031 154.621 141.913 155.71 141.913H392.67C393.758 141.913 394.641 141.031 394.641 139.942V138.628C394.641 137.539 393.758 136.657 392.67 136.657Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.769 147.169H155.71C154.621 147.169 153.739 148.052 153.739 149.14V150.454C153.739 151.543 154.621 152.425 155.71 152.425H370.769C371.858 152.425 372.74 151.543 372.74 150.454V149.14C372.74 148.052 371.858 147.169 370.769 147.169Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.961 136.657C460.315 136.657 463.845 133.127 463.845 128.773C463.845 124.419 460.315 120.889 455.961 120.889C451.607 120.889 448.077 124.419 448.077 128.773C448.077 133.127 451.607 136.657 455.961 136.657Z",
    fill: "#A7B9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.009 136.657C502.364 136.657 505.893 133.127 505.893 128.773C505.893 124.419 502.364 120.889 498.009 120.889C493.655 120.889 490.125 124.419 490.125 128.773C490.125 133.127 493.655 136.657 498.009 136.657Z",
    fill: "#A7B9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.985 136.657C481.339 136.657 484.869 133.127 484.869 128.773C484.869 124.419 481.339 120.889 476.985 120.889C472.631 120.889 469.101 124.419 469.101 128.773C469.101 133.127 472.631 136.657 476.985 136.657Z",
    fill: "#A7B9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.033 136.657C523.388 136.657 526.918 133.127 526.918 128.773C526.918 124.419 523.388 120.889 519.033 120.889C514.679 120.889 511.149 124.419 511.149 128.773C511.149 133.127 514.679 136.657 519.033 136.657Z",
    fill: "#A7B9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.058 136.657C544.412 136.657 547.942 133.127 547.942 128.773C547.942 124.419 544.412 120.889 540.058 120.889C535.703 120.889 532.174 124.419 532.174 128.773C532.174 133.127 535.703 136.657 540.058 136.657Z",
    fill: "#A7B9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4392 245.72C99.7677 245.72 113.004 232.483 113.004 216.155C113.004 199.826 99.7677 186.589 83.4392 186.589C67.1108 186.589 53.874 199.826 53.874 216.155C53.874 232.483 67.1108 245.72 83.4392 245.72Z",
    fill: "url(#paint1_linear_223_395)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.352 192.502H153.739C152.65 192.502 151.768 193.385 151.768 194.473V201.044C151.768 202.132 152.65 203.015 153.739 203.015H225.352C226.441 203.015 227.323 202.132 227.323 201.044V194.473C227.323 193.385 226.441 192.502 225.352 192.502Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.599 213.527H153.739C152.65 213.527 151.768 214.409 151.768 215.498V216.812C151.768 217.9 152.65 218.783 153.739 218.783H412.599C413.687 218.783 414.57 217.9 414.57 216.812V215.498C414.57 214.409 413.687 213.527 412.599 213.527Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.699 224.039H153.739C152.65 224.039 151.768 224.921 151.768 226.01V227.324C151.768 228.412 152.65 229.295 153.739 229.295H390.699C391.787 229.295 392.67 228.412 392.67 227.324V226.01C392.67 224.921 391.787 224.039 390.699 224.039Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.798 234.551H153.739C152.65 234.551 151.768 235.433 151.768 236.522V237.836C151.768 238.924 152.65 239.807 153.739 239.807H368.798C369.887 239.807 370.769 238.924 370.769 237.836V236.522C370.769 235.433 369.887 234.551 368.798 234.551Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.99 224.039C458.344 224.039 461.874 220.509 461.874 216.155C461.874 211.8 458.344 208.271 453.99 208.271C449.636 208.271 446.106 211.8 446.106 216.155C446.106 220.509 449.636 224.039 453.99 224.039Z",
    fill: "#A7B9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.038 224.039C500.393 224.039 503.922 220.509 503.922 216.155C503.922 211.8 500.393 208.271 496.038 208.271C491.684 208.271 488.154 211.8 488.154 216.155C488.154 220.509 491.684 224.039 496.038 224.039Z",
    fill: "#A7B9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.014 224.039C479.368 224.039 482.898 220.509 482.898 216.155C482.898 211.8 479.368 208.271 475.014 208.271C470.66 208.271 467.13 211.8 467.13 216.155C467.13 220.509 470.66 224.039 475.014 224.039Z",
    fill: "#A7B9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4392 339.672C99.7677 339.672 113.004 326.435 113.004 310.106C113.004 293.778 99.7677 280.541 83.4392 280.541C67.1108 280.541 53.874 293.778 53.874 310.106C53.874 326.435 67.1108 339.672 83.4392 339.672Z",
    fill: "url(#paint2_linear_223_395)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.352 286.454H153.739C152.65 286.454 151.768 287.337 151.768 288.425V294.995C151.768 296.084 152.65 296.966 153.739 296.966H225.352C226.441 296.966 227.323 296.084 227.323 294.995V288.425C227.323 287.337 226.441 286.454 225.352 286.454Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.599 307.478H153.739C152.65 307.478 151.768 308.361 151.768 309.449V310.763C151.768 311.852 152.65 312.734 153.739 312.734H412.599C413.687 312.734 414.57 311.852 414.57 310.763V309.449C414.57 308.361 413.687 307.478 412.599 307.478Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.699 317.99H153.739C152.65 317.99 151.768 318.873 151.768 319.961V321.275C151.768 322.364 152.65 323.246 153.739 323.246H390.699C391.787 323.246 392.67 322.364 392.67 321.275V319.961C392.67 318.873 391.787 317.99 390.699 317.99Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.798 328.502H153.739C152.65 328.502 151.768 329.385 151.768 330.473V331.787C151.768 332.876 152.65 333.758 153.739 333.758H368.798C369.887 333.758 370.769 332.876 370.769 331.787V330.473C370.769 329.385 369.887 328.502 368.798 328.502Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.99 317.99C458.344 317.99 461.874 314.461 461.874 310.106C461.874 305.752 458.344 302.222 453.99 302.222C449.636 302.222 446.106 305.752 446.106 310.106C446.106 314.461 449.636 317.99 453.99 317.99Z",
    fill: "#A7B9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.038 317.99C500.393 317.99 503.922 314.461 503.922 310.106C503.922 305.752 500.393 302.222 496.038 302.222C491.684 302.222 488.154 305.752 488.154 310.106C488.154 314.461 491.684 317.99 496.038 317.99Z",
    fill: "#A7B9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.014 317.99C479.368 317.99 482.898 314.461 482.898 310.106C482.898 305.752 479.368 302.222 475.014 302.222C470.66 302.222 467.13 305.752 467.13 310.106C467.13 314.461 470.66 317.99 475.014 317.99Z",
    fill: "#A7B9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.063 317.99C521.417 317.99 524.947 314.461 524.947 310.106C524.947 305.752 521.417 302.222 517.063 302.222C512.708 302.222 509.178 305.752 509.178 310.106C509.178 314.461 512.708 317.99 517.063 317.99Z",
    fill: "#A7B9C8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_223_395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M662.874 143.227H475.058C468.865 143.227 463.845 148.247 463.845 154.44V468.4C463.845 474.593 468.865 479.614 475.058 479.614H662.874C669.066 479.614 674.087 474.593 674.087 468.4V154.44C674.087 148.247 669.066 143.227 662.874 143.227Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M662.874 143.227H475.058C468.865 143.227 463.845 148.247 463.845 154.44V468.4C463.845 474.593 468.865 479.614 475.058 479.614H662.874C669.066 479.614 674.087 474.593 674.087 468.4V154.44C674.087 148.247 669.066 143.227 662.874 143.227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_223_395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.058 143.227H662.874C669.067 143.227 674.087 148.247 674.087 154.44V179.108H463.845V154.44C463.845 148.247 468.865 143.227 475.058 143.227Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M475.058 143.227H662.874C669.067 143.227 674.087 148.247 674.087 154.44V179.108H463.845V154.44C463.845 148.247 468.865 143.227 475.058 143.227Z",
    fill: "#00252E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.482 155.561H487.76C486.212 155.561 484.957 156.816 484.957 158.364V166.213C484.957 167.761 486.212 169.016 487.76 169.016H550.482C552.03 169.016 553.285 167.761 553.285 166.213V158.364C553.285 156.816 552.03 155.561 550.482 155.561Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.54 156.683H634.842C634.223 156.683 633.72 157.185 633.72 157.804C633.72 158.423 634.223 158.925 634.842 158.925H650.54C651.159 158.925 651.661 158.423 651.661 157.804C651.661 157.185 651.159 156.683 650.54 156.683Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.54 161.168H634.842C634.223 161.168 633.72 161.67 633.72 162.289C633.72 162.908 634.223 163.41 634.842 163.41H650.54C651.159 163.41 651.661 162.908 651.661 162.289C651.661 161.67 651.159 161.168 650.54 161.168Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.54 165.653H634.842C634.223 165.653 633.72 166.155 633.72 166.774C633.72 167.393 634.223 167.895 634.842 167.895H650.54C651.159 167.895 651.661 167.393 651.661 166.774C651.661 166.155 651.159 165.653 650.54 165.653Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.724 233.894C500.167 233.894 504.58 229.481 504.58 224.039C504.58 218.596 500.167 214.184 494.724 214.184C489.282 214.184 484.869 218.596 484.869 224.039C484.869 229.481 489.282 233.894 494.724 233.894Z",
    fill: "url(#paint3_linear_223_395)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.265 216.155H515.696C515.362 216.155 515.092 216.425 515.092 216.759V219.054C515.092 219.388 515.362 219.658 515.696 219.658H552.265C552.599 219.658 552.87 219.388 552.87 219.054V216.759C552.87 216.425 552.599 216.155 552.265 216.155Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.888 223.163H515.696C515.362 223.163 515.092 223.434 515.092 223.767V224.311C515.092 224.645 515.362 224.915 515.696 224.915H645.888C646.222 224.915 646.493 224.645 646.493 224.311V223.767C646.493 223.434 646.222 223.163 645.888 223.163Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.938 226.667H515.696C515.362 226.667 515.092 226.937 515.092 227.271V227.815C515.092 228.148 515.362 228.419 515.696 228.419H634.938C635.272 228.419 635.542 228.148 635.542 227.815V227.271C635.542 226.937 635.272 226.667 634.938 226.667Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.988 230.171H515.696C515.362 230.171 515.092 230.441 515.092 230.775V231.318C515.092 231.652 515.362 231.923 515.696 231.923H623.988C624.322 231.923 624.593 231.652 624.593 231.318V230.775C624.593 230.441 624.322 230.171 623.988 230.171Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.724 324.56C500.167 324.56 504.58 320.148 504.58 314.705C504.58 309.263 500.167 304.85 494.724 304.85C489.282 304.85 484.869 309.263 484.869 314.705C484.869 320.148 489.282 324.56 494.724 324.56Z",
    fill: "url(#paint4_linear_223_395)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.265 306.821H515.696C515.362 306.821 515.092 307.092 515.092 307.426V309.721C515.092 310.054 515.362 310.325 515.696 310.325H552.265C552.599 310.325 552.87 310.054 552.87 309.721V307.426C552.87 307.092 552.599 306.821 552.265 306.821Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.888 313.83H515.696C515.362 313.83 515.092 314.1 515.092 314.434V314.977C515.092 315.311 515.362 315.582 515.696 315.582H645.888C646.222 315.582 646.493 315.311 646.493 314.977V314.434C646.493 314.1 646.222 313.83 645.888 313.83Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.938 317.333H515.696C515.362 317.333 515.092 317.604 515.092 317.938V318.481C515.092 318.815 515.362 319.086 515.696 319.086H634.938C635.272 319.086 635.542 318.815 635.542 318.481V317.938C635.542 317.604 635.272 317.333 634.938 317.333Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.988 320.837H515.696C515.362 320.837 515.092 321.108 515.092 321.442V321.985C515.092 322.319 515.362 322.589 515.696 322.589H623.988C624.322 322.589 624.593 322.319 624.593 321.985V321.442C624.593 321.108 624.322 320.837 623.988 320.837Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.265 246.377H515.696C515.362 246.377 515.092 246.647 515.092 246.981V249.276C515.092 249.61 515.362 249.881 515.696 249.881H552.265C552.599 249.881 552.87 249.61 552.87 249.276V246.981C552.87 246.647 552.599 246.377 552.265 246.377Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.888 253.385H515.696C515.362 253.385 515.092 253.656 515.092 253.99V254.533C515.092 254.867 515.362 255.137 515.696 255.137H645.888C646.222 255.137 646.493 254.867 646.493 254.533V253.99C646.493 253.656 646.222 253.385 645.888 253.385Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.938 256.889H515.696C515.362 256.889 515.092 257.16 515.092 257.493V258.037C515.092 258.37 515.362 258.641 515.696 258.641H634.938C635.272 258.641 635.542 258.37 635.542 258.037V257.493C635.542 257.16 635.272 256.889 634.938 256.889Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.988 260.393H515.696C515.362 260.393 515.092 260.663 515.092 260.997V261.541C515.092 261.874 515.362 262.145 515.696 262.145H623.988C624.322 262.145 624.593 261.874 624.593 261.541V260.997C624.593 260.663 624.322 260.393 623.988 260.393Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.724 264.116C500.167 264.116 504.58 259.704 504.58 254.261C504.58 248.818 500.167 244.406 494.724 244.406C489.282 244.406 484.869 248.818 484.869 254.261C484.869 259.704 489.282 264.116 494.724 264.116Z",
    fill: "url(#paint5_linear_223_395)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.265 337.044H515.696C515.362 337.044 515.092 337.314 515.092 337.648V339.943C515.092 340.277 515.362 340.547 515.696 340.547H552.265C552.599 340.547 552.87 340.277 552.87 339.943V337.648C552.87 337.314 552.599 337.044 552.265 337.044Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.888 344.052H515.696C515.362 344.052 515.092 344.323 515.092 344.656V345.2C515.092 345.534 515.362 345.804 515.696 345.804H645.888C646.222 345.804 646.493 345.534 646.493 345.2V344.656C646.493 344.323 646.222 344.052 645.888 344.052Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.938 347.556H515.696C515.362 347.556 515.092 347.826 515.092 348.16V348.703C515.092 349.037 515.362 349.308 515.696 349.308H634.938C635.272 349.308 635.542 349.037 635.542 348.703V348.16C635.542 347.826 635.272 347.556 634.938 347.556Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.988 351.059H515.696C515.362 351.059 515.092 351.33 515.092 351.664V352.207C515.092 352.541 515.362 352.812 515.696 352.812H623.988C624.322 352.812 624.593 352.541 624.593 352.207V351.664C624.593 351.33 624.322 351.059 623.988 351.059Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.724 354.783C500.167 354.783 504.58 350.37 504.58 344.928C504.58 339.485 500.167 335.073 494.724 335.073C489.282 335.073 484.869 339.485 484.869 344.928C484.869 350.37 489.282 354.783 494.724 354.783Z",
    fill: "url(#paint6_linear_223_395)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.265 276.599H515.696C515.362 276.599 515.092 276.87 515.092 277.203V279.498C515.092 279.832 515.362 280.103 515.696 280.103H552.265C552.599 280.103 552.87 279.832 552.87 279.498V277.203C552.87 276.87 552.599 276.599 552.265 276.599Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.888 283.607H515.696C515.362 283.607 515.092 283.878 515.092 284.212V284.755C515.092 285.089 515.362 285.36 515.696 285.36H645.888C646.222 285.36 646.493 285.089 646.493 284.755V284.212C646.493 283.878 646.222 283.607 645.888 283.607Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.938 287.111H515.696C515.362 287.111 515.092 287.382 515.092 287.716V288.259C515.092 288.593 515.362 288.863 515.696 288.863H634.938C635.272 288.863 635.542 288.593 635.542 288.259V287.716C635.542 287.382 635.272 287.111 634.938 287.111Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.988 290.615H515.696C515.362 290.615 515.092 290.885 515.092 291.219V291.763C515.092 292.096 515.362 292.367 515.696 292.367H623.988C624.322 292.367 624.593 292.096 624.593 291.763V291.219C624.593 290.885 624.322 290.615 623.988 290.615Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.724 294.338C500.167 294.338 504.58 289.926 504.58 284.483C504.58 279.04 500.167 274.628 494.724 274.628C489.282 274.628 484.869 279.04 484.869 284.483C484.869 289.926 489.282 294.338 494.724 294.338Z",
    fill: "url(#paint7_linear_223_395)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.265 367.266H515.696C515.362 367.266 515.092 367.536 515.092 367.87V370.165C515.092 370.499 515.362 370.769 515.696 370.769H552.265C552.599 370.769 552.87 370.499 552.87 370.165V367.87C552.87 367.536 552.599 367.266 552.265 367.266Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.888 374.274H515.696C515.362 374.274 515.092 374.545 515.092 374.878V375.422C515.092 375.756 515.362 376.026 515.696 376.026H645.888C646.222 376.026 646.493 375.756 646.493 375.422V374.878C646.493 374.545 646.222 374.274 645.888 374.274Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.938 377.778H515.696C515.362 377.778 515.092 378.048 515.092 378.382V378.925C515.092 379.259 515.362 379.53 515.696 379.53H634.938C635.272 379.53 635.542 379.259 635.542 378.925V378.382C635.542 378.048 635.272 377.778 634.938 377.778Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.988 381.281H515.696C515.362 381.281 515.092 381.552 515.092 381.886V382.429C515.092 382.763 515.362 383.034 515.696 383.034H623.988C624.322 383.034 624.593 382.763 624.593 382.429V381.886C624.593 381.552 624.322 381.281 623.988 381.281Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.724 385.005C500.167 385.005 504.58 380.593 504.58 375.15C504.58 369.707 500.167 365.295 494.724 365.295C489.282 365.295 484.869 369.707 484.869 375.15C484.869 380.593 489.282 385.005 494.724 385.005Z",
    fill: "url(#paint8_linear_223_395)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.724 415.227C500.167 415.227 504.58 410.815 504.58 405.372C504.58 399.929 500.167 395.517 494.724 395.517C489.282 395.517 484.869 399.929 484.869 405.372C484.869 410.815 489.282 415.227 494.724 415.227Z",
    fill: "url(#paint9_linear_223_395)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.265 397.488H515.696C515.362 397.488 515.092 397.759 515.092 398.092V400.387C515.092 400.721 515.362 400.992 515.696 400.992H552.265C552.599 400.992 552.87 400.721 552.87 400.387V398.092C552.87 397.759 552.599 397.488 552.265 397.488Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.888 404.496H515.696C515.362 404.496 515.092 404.767 515.092 405.101V405.644C515.092 405.978 515.362 406.248 515.696 406.248H645.888C646.222 406.248 646.493 405.978 646.493 405.644V405.101C646.493 404.767 646.222 404.496 645.888 404.496Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.938 408H515.696C515.362 408 515.092 408.271 515.092 408.604V409.148C515.092 409.482 515.362 409.752 515.696 409.752H634.938C635.272 409.752 635.542 409.482 635.542 409.148V408.604C635.542 408.271 635.272 408 634.938 408Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.988 411.504H515.696C515.362 411.504 515.092 411.774 515.092 412.108V412.652C515.092 412.985 515.362 413.256 515.696 413.256H623.988C624.322 413.256 624.593 412.985 624.593 412.652V412.108C624.593 411.774 624.322 411.504 623.988 411.504Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.265 427.71H515.696C515.362 427.71 515.092 427.981 515.092 428.315V430.609C515.092 430.943 515.362 431.214 515.696 431.214H552.265C552.599 431.214 552.87 430.943 552.87 430.609V428.315C552.87 427.981 552.599 427.71 552.265 427.71Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.888 434.718H515.696C515.362 434.718 515.092 434.989 515.092 435.323V435.866C515.092 436.2 515.362 436.471 515.696 436.471H645.888C646.222 436.471 646.493 436.2 646.493 435.866V435.323C646.493 434.989 646.222 434.718 645.888 434.718Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.938 438.222H515.696C515.362 438.222 515.092 438.493 515.092 438.827V439.37C515.092 439.704 515.362 439.974 515.696 439.974H634.938C635.272 439.974 635.542 439.704 635.542 439.37V438.827C635.542 438.493 635.272 438.222 634.938 438.222Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.988 441.726H515.696C515.362 441.726 515.092 441.997 515.092 442.33V442.874C515.092 443.208 515.362 443.478 515.696 443.478H623.988C624.322 443.478 624.593 443.208 624.593 442.874V442.33C624.593 441.997 624.322 441.726 623.988 441.726Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.724 445.449C500.167 445.449 504.58 441.037 504.58 435.594C504.58 430.151 500.167 425.739 494.724 425.739C489.282 425.739 484.869 430.151 484.869 435.594C484.869 441.037 489.282 445.449 494.724 445.449Z",
    fill: "url(#paint10_linear_223_395)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_223_395",
    x: -3.43018,
    y: -3.42993,
    width: 650.725,
    height: 414.203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.145098 0 0 0 0 0.180392 0 0 0 0.181839 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_223_395"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_223_395",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_223_395",
    x: -3.43018,
    y: -3.42993,
    width: 650.725,
    height: 62.0483,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.145098 0 0 0 0 0.180392 0 0 0 0.181839 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_223_395"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_223_395",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_223_395",
    x: 454.845,
    y: 134.227,
    width: 228.241,
    height: 354.386,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.145098 0 0 0 0 0.180392 0 0 0 0.181839 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_223_395"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_223_395",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_223_395",
    x: 454.845,
    y: 134.227,
    width: 228.241,
    height: 53.881,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.145098 0 0 0 0 0.180392 0 0 0 0.181839 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_223_395"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_223_395",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_223_395",
    x1: 63.2157,
    y1: 83.1324,
    x2: 101.807,
    y2: 172.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF52C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_223_395",
    x1: 83.4392,
    y1: 186.589,
    x2: 83.4392,
    y2: 245.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_223_395",
    x1: 71.0059,
    y1: 280.541,
    x2: 107.21,
    y2: 346.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF52C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9952FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_223_395",
    x1: 487.789,
    y1: 209.776,
    x2: 499.848,
    y2: 237.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF52C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_223_395",
    x1: 487.789,
    y1: 300.443,
    x2: 499.848,
    y2: 328.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF52C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_223_395",
    x1: 494.724,
    y1: 244.406,
    x2: 494.724,
    y2: 264.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_223_395",
    x1: 494.724,
    y1: 335.073,
    x2: 494.724,
    y2: 354.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_223_395",
    x1: 490.58,
    y1: 274.628,
    x2: 502.648,
    y2: 296.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF52C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9952FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_223_395",
    x1: 490.58,
    y1: 365.295,
    x2: 502.648,
    y2: 387.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF52C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9952FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_223_395",
    x1: 487.789,
    y1: 391.109,
    x2: 499.848,
    y2: 419.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF52C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_223_395",
    x1: 494.724,
    y1: 425.739,
    x2: 494.724,
    y2: 445.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DFA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_223_395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 680,
    height: 485.527,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationMockups);
export default __webpack_public_path__ + "static/media/illustration-mockups.3d923c615eeb0577e325d2937667e82d.svg";
export { ForwardRef as ReactComponent };